export default abstract class Guid {
  static Empty = "00000000-0000-0000-0000-000000000000";
}
